import { createSelector } from '@reduxjs/toolkit';

import { createPriceSelector } from '../utils/createPriceSelector.ts';
import { selectBelowGradeFullBathCost } from './selectBelowGradeFullBathCost.ts';
import { selectBelowGradeHalfBathCost } from './selectBelowGradeHalfBathCost.ts';

const calculateBelowGradeBathsCost = (
  fullBathCost: ReturnType<typeof selectBelowGradeFullBathCost>,
  halfBathCost: ReturnType<typeof selectBelowGradeHalfBathCost>,
) => fullBathCost?.add(halfBathCost);

const selectBelowGradeBathsCost = createPriceSelector(
  [selectBelowGradeFullBathCost, selectBelowGradeHalfBathCost],
  calculateBelowGradeBathsCost,
);

export const selectBelowGradeBathsCostDisplay = createSelector(
  [selectBelowGradeBathsCost],
  (bathsCost) => bathsCost?.toString(true),
);
